import React from "react";
import "../supplierAndManufacturers.scss";
import { CategoryOrSubcategoryItem } from "./TableBody";
import { NoData } from "./ViewBody";
import { useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../constants/app.constants";
import httpUtils from "../../../../Utils/http.utils";

const SubscriptionData = {
  icon: '/images/settings-nav/subsription_icon.svg',
  name: 'HP Hardware Replacement',
  categoryName: 'Hardware',
  categoryColor: '#5244B3',
  status: { id: 0, label: 'Active' },

}

const SubscriptionsBlock = ({ data, isActive = false, clientId = 0 }) => {
  const navigate = useNavigate();
  const handleRedirectClick = () => {
    const query = httpUtils.generateQueryString({
      subTitle: data?.SubscriptionTitle,
      invoiceId: data?.ObjId_Invoice,
      categoryId: data?.ObjId_Category,
      subCategoryId: data?.ObjId_SubCategory,
    })
    navigate(`${ROUTE_PATHS.mspv2.clients.technologySpend(clientId)}?${query}`)
  }
  return (
    <div>
      {!data || data === null ? <NoData /> :
        <div className="subscriptionsBlock">
          <Header
            icon={"/images/settings-nav/subsription_icon.svg"}
            name={data?.SubscriptionTitle}
            categoryName={data?.CategoryName}
            categoryColor={data?.CategoryColor}
            status={data?.Status}
            statusColor={data?.StatusColor}
            isActive={isActive}
            onRedirectClick={handleRedirectClick}
          />
          <SubscriptionDetails data={data} />
        </div>
      }
    </div>
  );
};

export default SubscriptionsBlock;

const Header = ({
  icon = '',
  name = '',
  categoryName = '',
  categoryColor = '',
  status = '',
  statusColor = '',
  isActive = {},
  onRedirectClick = () => {},
}) => (
  <div className="subscriptionHeader w-100">
    <div className="d-flex align-items-center">
      <img alt="" src={icon} width={20} height={20} className="mr-2" />
      <div>
        <div>{name}</div>
        <CategoryOrSubcategoryItem color={categoryColor} name={categoryName} />
      </div>
    </div>
    <div className="d-flex align-items-center">
      <StatusItem name={status} statusColor={statusColor} />
      <img alt="" src={'/images/supply-chain/redirect-icon.svg'} width={12} height={12} className="ml-2 pointer" onClick={onRedirectClick} />
    </div>
  </div>
)

const StatusItem = ({ name = '', statusColor = '' }) => (<div className={`statusItem`} style={{ backgroundColor: statusColor }}>{name}</div>)

const SubscriptionDetails = ({ data = {} }) => (
  <div className="subscriptionsDetails">
    <DetailItem label={'Amount'} data={data?.Amount} />
    <DetailItem label={'Renewal'} data={`${data?.EndDate?.Day}/${data?.EndDate?.Month}/${data?.EndDate?.Year}`} />
    <DetailItem label={'Payments'} data={data?.Invoices} />
    <DetailItem label={'Supplier'} data={data?.Supplier} />
  </div>
)

const DetailItem = ({
  label = '',
  data = ''
}) => (
  <div className="dataItem">
    <div className="label">{label}</div>
    <div className="data">{data}</div>
  </div>
)